import React from 'react';
import './PackageCard.css';

import img1 from '../assets/package-1.png';
import img2 from '../assets/package-2.png';
import img3 from '../assets/package-3.png';
import img4 from '../assets/package-4.png';
import img5 from '../assets/package-5.png';

const imageMap = {
  'package-1.png': img1,
  'package-2.png': img2,
  'package-3.png': img3,
  'package-4.png': img4,
  'package-5.png': img5,
};

function PackageCard({ image, title, placeCount, onClick }) {
  const resolvedImage = imageMap[image] || image;

  return (
    <div
      className="package-card"
      style={{ backgroundImage: `url(${resolvedImage})` }}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => e.key === 'Enter' && onClick() : undefined}
    >
      <div className="package-card-content">
        <h3 className="package-card-title">{title}</h3>
        <div className="place-counter">
          <span className="count">{placeCount}</span>
          <span className="label">направлений</span>
        </div>
      </div>
    </div>
  );
}

export default PackageCard;
